<div class="form-group field">
  <p-float-label [variant]="labelLocation">
    <p-inputgroup class="flex">
      @if (showButtons) {
        <p-inputgroup-addon>
          <p-button
            [icon]="defaultIcon.Previous"
            styleClass="vertical-align-middle"
            (click)="moveBackDay()"
            pTooltip="Prior Day"
          />
        </p-inputgroup-addon>
      }
      <p-datepicker
        #dateControl
        [showIcon]="true && !readonly"
        [(ngModel)]="dateValue"
        [inputId]="fieldName?.toString() + groupName?.toString()"
        [showClear]="showClear ?? !isRequired()"
        [showOnFocus]="false"
        [selectOtherMonths]="true"
        [s-blur]="attribute?.dataClassification"
        appendTo="body"
        [shortYearCutoff]="10"
        (onInput)="onInput($event)"
        (onBlur)="onChange()"
        (onSelect)="onChange()"
        (onClear)="onChange()"
        (onShow)="onShow($event)"
        (onClose)="onClose($event)"
        [readonlyInput]="readonly"
        [touchUI]="layoutService.mobile$ | async"
        styleClass="min-w-24"
        class="flex"
        [size]="size"
      />
      @if (showButtons) {
        <p-inputgroup-addon>
          <p-button
            [icon]="defaultIcon.Today"
            styleClass="vertical-align-middle"
            (click)="moveToToday()"
            pTooltip="Today"
          />
        </p-inputgroup-addon>
        <p-inputgroup-addon>
          <p-button
            [icon]="defaultIcon.Next"
            styleClass="vertical-align-middle"
            (click)="moveForwardDay()"
            pTooltip="Next Day"
          />
        </p-inputgroup-addon>
      }
      <label [for]="fieldName?.toString() + groupName?.toString()"
        >{{ label ?? 'Date' }}
        @if (isRequired()) {
          <span style="color: red">*</span>
        }
      </label>
    </p-inputgroup>
  </p-float-label>
  <ng-content></ng-content>
  @if (displayHint) {
    <small class="block" style="font-weight: normal">{{ displayHint }}</small>
  }
  <s-form-error-input
    [groupName]="groupName"
    [fieldName]="fieldName"
    [form]="form"
    [apiError]="apiError"
    [schema]="schema"
  />
</div>
